import { render, staticRenderFns } from "./create.vue?vue&type=template&id=48c9b6c5&scoped=true&"
import script from "./create.vue?vue&type=script&lang=ts&"
export * from "./create.vue?vue&type=script&lang=ts&"
import style0 from "./create.vue?vue&type=style&index=0&id=48c9b6c5&lang=scss&scoped=true&"
import style1 from "./create.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9b6c5",
  null
  
)

export default component.exports